import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { updateNavbarState } from './navbar_actions';
import { recursiveRemovePreserve } from '../utils/HistoryUtils';
import QueryString from 'qs';

export const INVOICES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('INVOICES');
export const INVOICES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	INVOICES_CRUD_ACTION_CONSTANTS
);

const originalFn = INVOICES_CRUD_ACTION_CREATORS.updateSuccess;
INVOICES_CRUD_ACTION_CREATORS.updateSuccess = function (proposal) {
	return function (dispatch, getState) {
		const { navbar } = getState();
		const { backlinkTitle, navbarBackgroundColor } = navbar;
		if (navbar && navbar.backlinkTo) {
			const [path, queryParams] = navbar.backlinkTo.split('?');
			let urlSearchParams = QueryString.parse(queryParams);
			const backlinkTo = `${path}?${recursiveRemovePreserve(urlSearchParams)}`;
			dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor));
		}
		dispatch(originalFn(proposal));
	};
};
